module.exports = __webpack_public_path__ + "assets/media/profile.b7ca040b.svg";